"use client";

import { Typography } from "@/components/ui/typography";
import { ServicesPricingPlans } from "@/components/screen/global-components/services";

type ServicePlanItem = {
  fields?: {
    serviceName?: string;
    servicePrice?: string;
    serviceDescriptions?: string;
    mainButton?: string;
    secondaryButton?: string;
    secondaryButtonUrl?:string;
    mainButtonUrl?:string;
    highlight?: string;
    icon?: {
      fields?: {
        file?: {
          url?: string;
        };
        title?: string;
      };
    };
  };
};

type DocumentsServiceCardProps = {
  content?: {
    serviceTitle?: string;
    serviceDescriptions?: string;
    servicePlan?: ServicePlanItem[];
  };
};

export default function DocumentsServiceCard({
  content,
}: DocumentsServiceCardProps) {
  const title = content?.serviceTitle ?? "Our Services";
  const description = content?.serviceDescriptions ?? "";
  const servicePlan = content?.servicePlan ?? [];

  const cards = servicePlan.map((item, idx) => ({
    image: item.fields?.icon?.fields?.file?.url
      ? "https:" + item.fields.icon.fields.file.url
      : "/placeholder.svg",
    title: item.fields?.serviceName ?? "",
    price: item.fields?.servicePrice ?? "",
    description: item.fields?.serviceDescriptions ?? "",
    mainButton: item.fields?.mainButton,
    mainButtonLink: item.fields?.mainButtonUrl,
    secondaryButton: item.fields?.secondaryButton,
    secondaryButtonLink: item.fields?.secondaryButtonUrl,
    highlight: idx === 2 ? "accent" : undefined,
  }));

  return (
    <section className="section">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col justify-center gap-6 md:gap-4 md:w-full md:max-w-[800px] md:mx-auto">
          <Typography variant="heading4" className="text-center">
            <h2>{title}</h2>
          </Typography>
          <div className="flex justify-center text-gray-600">
            <Typography variant="subHeadingSm" className="text-center" asChild>
              <p>{description}</p>
            </Typography>
          </div>
        </div>
        <ServicesPricingPlans className="mt-6 lg:mt-14" cards={cards} />
      </div>
    </section>
  );
}
